export default __webpack_public_path__ + "static/media/business-problem5-sc.038bd659.png";